import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk-legacy/ui-react-utils';

import MarketValueHeader from '../../../../../../../src/components/common/market-value-header';

import styles from './asset-header.styles';

function AssetHeader({
  marketValue,
  dayChangeValue,
  dayChangePercent,
  currency,
  marketData,
  messages,
  location,
  isPopoverRequired

}) {
  return (
    <View style={styles.container} testID="asset-header">
      <MarketValueHeader
        marketValue={marketData.marketValue.value}
        marketValueAsOfDate={marketData.asOfDate}
        marketValueUnit={currency}
        dayChange={marketData.dayChange.value}
        dayChangePercentage={marketData.dayChange.percent}
        dayChangeUnit={currency}
        messages={messages}
        location = {location}
        isPopoverRequired={isPopoverRequired}
      />
    </View>
  );
}

AssetHeader.propTypes = {
  marketValue: PropTypes.number,
  dayChangeValue: PropTypes.number,
  dayChangePercent: PropTypes.number,
  currency: PropTypes.string,
  marketData: PropTypes.object,
  isPopoverRequired: PropTypes.bool
};

export default pure(AssetHeader);
